import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import i18n from '../i18n/i18n';
import { DEFAULT_QR_CODE_COLOR } from '../theme';

export type UserProfile = {
  _id: string;
  companyName: string;
  companyLogo: string;
  username: string;
  email: string;
  qrCodeColor: string;
  newsletterSubscribed: boolean;
};

export const initialUserProfile: UserProfile = {
  _id: '',
  companyName: '',
  companyLogo: '',
  username: '',
  email: '',
  qrCodeColor: DEFAULT_QR_CODE_COLOR,
  newsletterSubscribed: false,
};

export type UserPermissions = {
  _id: string;
  productSlots: number;
  layoutSlots: number;
};

export const initialPermissions: UserPermissions = {
  _id: '',
  productSlots: 0,
  layoutSlots: 0,
};

interface PortfolioStore {
  userProfile: UserProfile;
  userPermissions: UserPermissions;
  setUserProfile: (profile: Partial<UserProfile>) => void;
  setUserPermissions: (permissions: UserPermissions) => void;
  reset: () => void;
}

// Create your store
export const useStore = create<PortfolioStore>()(
  devtools(
    persist(
      (set) => ({
        // Define your initial state
        userProfile: initialUserProfile,
        userPermissions: initialPermissions,
        // Define your actions
        setUserProfile: (profile) =>
          set((state) => ({ ...state, userProfile: { ...state.userProfile, ...profile } })),
        setUserPermissions: (permissions) =>
          set({
            userPermissions: permissions ?? initialPermissions,
          }),
        reset: () =>
          set({
            userProfile: initialUserProfile,
            userPermissions: initialPermissions,
          }),
      }),
      {
        name: 'portfolio-store',
        /* storage: createJSONStorage(() => sessionStorage)*/
      }
    )
  )
);

//export const { setUserProfile } = useStore;

// Language store
interface LanguageState {
  language: 'de' | 'en';
  setLanguage: (lang: 'de' | 'en') => void;
}

export const useLanguageStore = create<LanguageState>()(
  persist(
    (set) => ({
      language: 'de',
      setLanguage: (lang) => {
        i18n.changeLanguage(lang);
        set({ language: lang });
      },
    }),
    {
      name: 'language-store',
    }
  )
);
